// Material Dashboard 2 React layouts
import DiamondIcon from "@mui/icons-material/Diamond";
import Dashboard from "layouts/dashboard";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import SignIn from "layouts/authentication/sign-in";
import Users from "layouts/users";
import Stores from "layouts/stores";
import Categories from "layouts/categories";
import Attributes from "layouts/attributes";
import AttributeValues from "layouts/attribute_values";
import Brands from "layouts/brands";
// @mui icons
import Icon from "@mui/material/Icon";
import Products from "layouts/products";
import StoreDocumntation from "layouts/store_documntation";
import LocationTypes from "layouts/locationTypes";
import Locations from "layouts/locations";
import Currency from "layouts/currency";
import PaymentMethods from "layouts/payment_method";
import PaymentConfigs from "layouts/payment_config";
import ShippingConfigs from "layouts/shipping_config";
import ShippingMethods from "layouts/shipping_method";
import ShippingPricing from "layouts/shipping_pricing";
import StoresOrders from "layouts/stores_orders";
import Wallets from "layouts/wallets";
import CustomerWallets from "layouts/wallets/customerWallets";
import StoreWallets from "layouts/wallets/storeWallets";
import WalletOperations from "layouts/wallets/WalletOperations";
import WalletsOverview from "layouts/wallets/WalletsOverview";
import Offers from "layouts/offers/offers";
import OffersIndex from "layouts/offers/index";
import BusinessActivities from "layouts/business_activities";
import MarketTypes from "layouts/marketTypes";
import LoyaltyTiers from "layouts/offers/loyalty_tiers";
import Markets from "layouts/markets";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import StoreIcon from "@mui/icons-material/Store";
import CategoryIcon from "@mui/icons-material/Category";
import ListAltIcon from "@mui/icons-material/ListAlt";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PaymentIcon from "@mui/icons-material/Payment";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import SettingsIcon from "@mui/icons-material/Settings";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LoginIcon from "@mui/icons-material/Login";
import ScreenShareIcon from "@mui/icons-material/ScreenShare";
import StoreDocumntationPreview from "layouts/store_documntation/components/StoreDocumntationPreview";
import OffersPreviewPage from "layouts/offers/components/OffersPreviewPage";
import ChatInterface from "layouts/chats";
import DisplayContext from "layouts/display-context";
import Ads from "layouts/ads";
import { AdbSharp, Feed, Insights } from "@mui/icons-material";
import CategoryRecommendations from "layouts/category-recommendations";
import ProductRecommendations from "layouts/product_recommendations";
import OrderDetails from "layouts/stores_orders/OrderDetails";
import EventCategory from "layouts/events/event-category";
import EventIcon from "@mui/icons-material/Event";
import PlaceCategory from "layouts/events/place_category";
import PlaceIcon from "@mui/icons-material/Place";
import HestoricPlace from "layouts/events/hestoric_place";
import HistoryIcon from "@mui/icons-material/History";
import Events from "layouts/events/events";
import SalesReport from "components/Reports/SalesReport";
import Client from "layouts/client/Client";
import PlansScreen from "layouts/plans/PlanScreen";
import LogsSection from "layouts/commissions/LogsSection";
import CommissionsSection from "layouts/commissions/CommissionSection";
import RulesSection from "layouts/commissions/RulesSection";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import Permissions from "layouts/role-permission/Permissions";
import SubscriptionsScreen from "layouts/subscriptions/SubscriptionsScreen";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import Accounts from "layouts/accountting/Accounts";
import BalanceSheetReport from "layouts/financialReports/Balance/BalanceSheetReport";
import JournalEntriesScreen from "layouts/financialReports/journal-entries/JournalEntries";
import FinancialPeriods from "layouts/financialReports/financial-periods/FinancialPeriods";
import LinearScaleIcon from "@mui/icons-material/LinearScale";
import LineAxisIcon from "@mui/icons-material/LineAxis";
import IncomeStatementReport from "layouts/financialReports/income-statement/IncomeStatementReport";
import InsightsIcon from "@mui/icons-material/Insights";
import TrialBalanceReport from "layouts/financialReports/trial-balance/TrialBalanceReport";
import MonitorWeightIcon from "@mui/icons-material/MonitorWeight";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import FinancialTransactionsReport from "layouts/financialReports/financial-transactions/FinancialTransactionsReport";
import FinancialAnalysisReport from "layouts/financialReports/financial-analysis/FinancialAnalysisReport";
import AccountsTree from "layouts/financialReports/account-tree/AccountsTree";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FeedbackAdmin from "layouts/complaints/FeedbackAdmin";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import ReviewsIcon from "@mui/icons-material/Reviews";
import Ratting from "layouts/Ratting/Ratting";
import UsersPositionOverview from "layouts/financialReports/user-country/users-overview";
import GroupsIcon from '@mui/icons-material/Groups';
import Groups from "layouts/groups/groups";
const routes = [
  {
    type: "collapse",
    name: "الرئيسية",
    key: "dashboard",
    icon: <DashboardIcon fontSize="small" />,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "المستخدمين",
    key: "users",
    icon: <PeopleIcon fontSize="small" />,
    route: "/users",
    component: <Users />,
  },
  {
    type: "collapse",
    name: "النشاطات التجارية",
    key: "business_activities",
    icon: <ListAltIcon fontSize="small" />,
    route: "/business_activities",
    component: <BusinessActivities />,
  },
  {
    type: "collapse",
    name: "المناديب",
    key: "agents",
    icon: <SupportAgentIcon fontSize="small" />,
    collapse: [
      {
        name: "الفرق",
        key: "groups",
        icon: <GroupsIcon fontSize="small" />,
        route: "/groups",
        component: <Groups />,
      },
    ],
  },
  {
    type: "collapse",
    name: "المتاجر",
    key: "main-merchants",
    icon: <StoreIcon fontSize="small" />,
    collapse: [
      {
        name: "المتاجر",
        key: "stores",
        icon: <StoreIcon fontSize="small" />,
        route: "/stores",
        component: <Stores />,
      },
      {
        name: "وثائق المتاجر",
        key: "store_documntation",
        icon: <ListAltIcon fontSize="small" />,
        route: "/storeDocumntation",
        component: <StoreDocumntation />,
      },
      {
        name: "الطلبات",
        key: "stores_orders",
        icon: <Inventory2Icon fontSize="small" />,
        route: "/stores_orders",
        component: <StoresOrders />,
      },
    ],
  },
  {
    type: "collapse",
    name: "الدردشات",
    key: "chats",
    icon: <Icon fontSize="small">chat</Icon>,
    route: "/chats",
    component: <ChatInterface />,
  },
  {
    type: "collapse",
    name: "الفئات",
    key: "main-categories",
    icon: <CategoryIcon fontSize="small" />,
    collapse: [
      {
        name: "كل الفئات",
        key: "categories",
        icon: <CategoryIcon fontSize="small" />,
        route: "/categories",
        component: <Categories />,
      },
      {
        name: "الفئات الموصى بها",
        key: "category-recommendations",
        icon: <CategoryIcon fontSize="small" />,
        route: "/category-recommendations",
        component: <CategoryRecommendations />,
      },
    ],
  },
  {
    type: "collapse",
    name: "السمات",
    key: "main-attributes",
    icon: <ListAltIcon fontSize="small" />,
    collapse: [
      {
        name: "كل السمات",
        key: "attributes",
        icon: <ListAltIcon fontSize="small" />,
        route: "/attributes",
        component: <Attributes />,
      },
      {
        name: "قيم السمات",
        key: "attributes_values",
        icon: <PriceChangeIcon fontSize="small" />,
        route: "/attributes_values",
        component: <AttributeValues />,
      },
    ],
  },
  {
    type: "collapse",
    name: "الماركات",
    key: "brands",
    icon: <BrandingWatermarkIcon fontSize="small" />,
    route: "/brands",
    component: <Brands />,
  },
  {
    type: "collapse",
    name: "المنتجات",
    key: "products-items",
    icon: <Inventory2Icon fontSize="small" />,
    collapse: [
      {
        name: "المنتجات",
        key: "products",
        icon: <Inventory2Icon fontSize="small" />,
        route: "/products",
        component: <Products />,
      },
      {
        name: "المنتجات الموصى بها",
        key: "product-recommendations",
        icon: <Inventory2Icon fontSize="small" />,
        route: "/product-recommendations",
        component: <ProductRecommendations />,
      },
    ],
  },
  {
    type: "collapse",
    name: "الاسواق",
    key: "main-marketTypes",
    icon: <LocalMallIcon fontSize="small" />,
    collapse: [
      {
        name: "انواع الاسواق",
        key: "marketTypes",
        icon: <LocalMallIcon fontSize="small" />,
        route: "/marketTypes",
        component: <MarketTypes />,
      },
      {
        name: "الاسواق",
        key: "markets",
        icon: <StoreIcon fontSize="small" />,
        route: "/markets",
        component: <Markets />,
      },
    ],
  },
  {
    type: "collapse",
    name: " المحافظ الالكترونية",
    key: "wallets",
    icon: <AccountBalanceWalletIcon fontSize="small" />,
    collapse: [
      {
        name: "جميع المحافظ",
        key: "all-wallets",
        icon: <AccountBalanceWalletIcon fontSize="small" />,
        route: "/wallets",
        component: <Wallets />,
      },
      {
        name: "محافظ  العملاء",
        key: "customer-wallets",
        icon: <PeopleIcon fontSize="small" />,
        route: "/customer_wallets",
        component: <CustomerWallets />,
      },
      {
        name: "محافظ  المتاجر",
        key: "store-wallets",
        icon: <StoreIcon fontSize="small" />,
        route: "/store_wallets",
        component: <StoreWallets />,
      },
      {
        name: "جميع العمليات",
        key: "wallets-overview",
        icon: <ListAltIcon fontSize="small" />,
        route: "/wallets/overview",
        component: <WalletsOverview />,
      },
    ],
  },
  {
    key: "customer_wallets_operations",
    route: "/customer_wallets/:walletId",
    component: <WalletOperations />,
  },
  {
    key: "store_wallets_operations",
    route: "/store_wallets/:walletId",
    component: <WalletOperations />,
  },
  {
    key: "wallets_overview_duplicate",
    route: "/wallets/overview",
    component: <WalletsOverview />,
  },
  {
    name: "معاينة وثيقة المتجر",
    key: "store_documntation_preview",
    route: "/storeDocumntation/preview/:id",
    component: <StoreDocumntationPreview />,
    noSidenav: true,
  },
  {
    type: "collapse",
    name: "العملاء",
    key: "customers",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/customers",
    component: <Client />,
  },
  {
    type: "collapse",
    name: "العروض",
    key: "offers",
    icon: <LocalOfferIcon fontSize="small" />,
    route: "/offers",
    component: <OffersIndex />,
  },
  {
    key: "offers_new",
    route: "/offers/new",
    component: <Offers />,
  },
  {
    key: "offers_new_with_id",
    route: "/offers/new/:id",
    component: <Offers />,
  },
  {
    key: "offers_loyalty_tiers",
    route: "/offers/loyalty_tiers",
    component: <LoyaltyTiers />,
  },
  {
    type: "collapse",
    name: " الفعاليات",
    key: "events",
    icon: <EventIcon fontSize="small" />,
    collapse: [
      {
        name: "تصنيفات الفعاليات",
        key: "event-category",
        icon: <EventIcon fontSize="small" />,
        route: "/event-category",
        component: <EventCategory />,
      },
      {
        name: "فئات الاماكن",
        key: "place-category",
        icon: <PlaceIcon fontSize="small" />,
        route: "/place-category",
        component: <PlaceCategory />,
      },
      {
        name: "الاماكن التاريخية",
        key: "hestoric-place",
        icon: <HistoryIcon fontSize="small" />,
        route: "/hestoric-place",
        component: <HestoricPlace />,
      },
      {
        name: "الفعاليات",
        key: "events",
        icon: <EventIcon fontSize="small" />,
        route: "/events",
        component: <Events />,
      },
    ],
  },

  {
    type: "collapse",
    name: "الشكاوي",
    key: "feedback",
    icon: <ConnectWithoutContactIcon fontSize="small" />,
    route: "/feedback",
    component: <FeedbackAdmin />,
  },

  {
    type: "collapse",
    name: "الشاشات",
    key: "display-context",
    icon: <ScreenShareIcon fontSize="small" />,
    route: "/display-context",
    component: <DisplayContext />,
  },

  {
    type: "collapse",
    name: "الاعلانات",
    key: "ads",
    icon: <AdbSharp fontSize="small" />,
    route: "/ads",
    component: <Ads />,
  },
  {
    type: "collapse",
    name: "التقييمات",
    key: "rattings",
    icon: <ReviewsIcon fontSize="small" />,
    route: "/rattings",
    component: <Ratting />,
  },
  {
    type: "collapse",
    name: "الخطط والاشتراكات",
    key: "plans-subscriptions",
    icon: <ReceiptLongIcon fontSize="small" />,
    collapse: [
      {
        name: "الخطط",
        key: "plans",
        icon: <ReceiptLongIcon fontSize="small" />,
        route: "/plans",
        component: <PlansScreen />,
      },
      {
        name: "الاشتراكات",
        key: "subscriptions",
        icon: <SubscriptionsIcon fontSize="small" />,
        route: "/subscriptions",
        component: <SubscriptionsScreen />,
      },
    ],
  },
  {
    type: "collapse",
    name: "العمولات",
    key: "commissions-section",
    icon: <DiamondIcon fontSize="small" />,
    route: "/commissions",
    collapse: [
      {
        name: "العمولات",
        key: "commissions",
        icon: <DiamondIcon fontSize="small" />,
        route: "/commissions",
        component: <CommissionsSection />,
      },
      {
        name: "سجل العمولات",
        key: "commissions-logs",
        icon: <DiamondIcon fontSize="small" />,
        route: "/commissions-logs",
        component: <LogsSection />,
      },
      {
        name: "اعدادات العمولات",
        key: "commissions-settings",
        icon: <DiamondIcon fontSize="small" />,
        route: "/commissions-settings",
        component: <RulesSection />,
      },
    ],
  },
  {
    type: "collapse",
    name: "التقارير",
    key: "sales-reports",
    icon: <AutoGraphIcon fontSize="small" />,
    route: "/sales-reports",
    collapse: [
      {
        name: "تقارير المبيعات",
        key: "overview-sales-reports",
        icon: <AutoGraphIcon fontSize="small" />,
        route: "/sales-reports",
        component: <SalesReport />,
      },
      {
        name: "تقارير المالية",
        key: "financial-reports",
        icon: <AutoGraphIcon fontSize="small" />,
        route: "/financial-reports",
        component: <BalanceSheetReport />,
      },
      {
        name: "تقارير الدخل",
        key: "income-statement",
        icon: <InsightsIcon fontSize="small" />,
        route: "/income-statement",
        component: <IncomeStatementReport />,
      },
      {
        name: " تقرير ميزان المراجعة",
        key: "trial-balance",
        icon: <MonitorWeightIcon fontSize="small" />,
        route: "/trial-balance",
        component: <TrialBalanceReport />,
      },
      {
        name: " الحركات الحسابية",
        key: "financial-transactions",
        icon: <TransferWithinAStationIcon fontSize="small" />,
        route: "/financial-transactions",
        component: <FinancialTransactionsReport />,
      },
      {
        name: " التحليل المالي",
        key: "financial-analysis",
        icon: <TransferWithinAStationIcon fontSize="small" />,
        route: "/financial-analysis",
        component: <FinancialAnalysisReport />,
      },
      {
        name: " شجرة الحسابات",
        key: "account-tree",
        icon: <AccountTreeIcon fontSize="small" />,
        route: "/account-tree",
        component: <AccountsTree />,
      },
      {
        name: " تقارير  مواقع المستخدمين",
        key: "users-reports",
        icon: <MonitorWeightIcon fontSize="small" />,
        route: "/users-reports",
        component: <UsersPositionOverview />,
      },
    ],
  },
  {
    type: "collapse",
    name: "التقارير المحاسبية",
    key: "accounts-reports",
    icon: <AccountBalanceIcon fontSize="small" />,
    collapse: [
      {
        name: "الحسابات",
        key: "accounts",
        icon: <AssuredWorkloadIcon fontSize="small" />,
        route: "/accounts",
        component: <Accounts />,
      },
      {
        name: "القيود المحاسبية",
        key: "journal-entries",
        icon: <LineAxisIcon fontSize="small" />,
        route: "/journal-entries",
        component: <JournalEntriesScreen />,
      },
      {
        name: " الفترات المحاسبية",
        key: "financial-periods",
        icon: <LinearScaleIcon fontSize="small" />,
        route: "/financial-periods",
        component: <FinancialPeriods />,
      },
    ],
  },
  {
    type: "collapse",
    name: "الاعدادات",
    key: "settings",
    icon: <SettingsIcon fontSize="small" />,
    collapse: [
      {
        name: "تصنيفات المواقع",
        key: "location-types",
        icon: <LocationOnIcon fontSize="small" />,
        route: "/LocationTypes",
        component: <LocationTypes />,
      },
      {
        name: "المواقع",
        key: "locations",
        icon: <LocationOnIcon fontSize="small" />,
        route: "/locations",
        component: <Locations />,
      },
      {
        name: "العملات",
        key: "currency",
        icon: <MonetizationOnIcon fontSize="small" />,
        route: "/currency",
        component: <Currency />,
      },
      {
        name: "طرق الدفع",
        key: "payment_Methods",
        icon: <PaymentIcon fontSize="small" />,
        route: "/payment_methods",
        component: <PaymentMethods />,
      },
      {
        name: "اعدادات طرق الدفع",
        key: "payment_configs",
        icon: <SettingsIcon fontSize="small" />,
        route: "/payment_configs",
        component: <PaymentConfigs />,
      },
      {
        name: "طرق الشحن",
        key: "shipping_methods",
        icon: <LocalShippingIcon fontSize="small" />,
        route: "/shipping_methods",
        component: <ShippingMethods />,
      },
      {
        name: "اعدادات  طرق الشحن",
        key: "shipping_configs",
        icon: <SettingsIcon fontSize="small" />,
        route: "/shipping_configs",
        component: <ShippingConfigs />,
      },
      {
        name: "اسعار شركات الشحن",
        key: "shipping_pricing",
        icon: <PriceChangeIcon fontSize="small" />,
        route: "/shipping_pricing",
        component: <ShippingPricing />,
      },
    ],
  },
  {
    type: "collapse",
    name: "تسجيل الدخول",
    key: "sign-in",
    icon: <LoginIcon fontSize="small" />,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "route",
    name: "معاينة العرض",
    key: "offers-preview",
    route: "/offers/preview/:id",
    component: <OffersPreviewPage />,
  },
  {
    type: "route",
    name: "تفاصيل الطلب",
    key: "stores_orders_details",
    route: "/stores_orders/details/:id",
    component: <OrderDetails />,
    noCollapse: true,
    hideInSidenav: true,
  },
];

export default routes;
